import { shorelightColorPalette } from '@shorelight/super-form/utils/ThemeUtils/defaultColorPalette';

export const colorPalette = {
  ...shorelightColorPalette
};
